import { GetStaticPropsContext, NextPage, GetStaticProps } from "next";

import Layout from "@/components/layouts/default";

import { StrapiAPI } from "@/api/strapi-api";
import { BlogPostI } from "@/interfaces/strapi/collection-types";
import { Module404 } from "@/components/modules/404";
import { ISR_REVALIDATE_INTERVAL_SECONDS } from "@/constants/next-page";
import { BlogModule } from "@/components/modules/blog";
import { StrapiPaginationI } from "@/interfaces/strapi/pagination";
import { getEntityAttributesFromStrapiList } from "@/helpers/strapi";
import Router from "@/helpers/router";

export interface BlogPagePropsI {
  posts?: BlogPostI[];
  pagination?: StrapiPaginationI;
}

const ALL_BLOG_POSTS_META = {
  title: "Outbound Sales Insights & Tips | Glencoco",
  description:
    "Stay updated with trends, insights, and tips in outbound sales. Expert advice to drive business growth.",
  canonical: Router.blog(),
};

const BlogPage: NextPage<BlogPagePropsI> = ({ posts, pagination }) => (
  <Layout meta={ALL_BLOG_POSTS_META}>
    {posts ? (
      <BlogModule posts={posts} pagination={pagination} />
    ) : (
      <Module404 />
    )}
  </Layout>
);

export const getStaticProps: GetStaticProps = async (
  ctx: GetStaticPropsContext
) => {
  const pageIndex = ctx?.params?.page_index as string;
  const api = StrapiAPI();

  let posts: BlogPostI[] | undefined;
  let pagination: StrapiPaginationI | undefined;

  try {
    const { data, status } = await api.getBlogPosts(pageIndex || 0);

    if (status === 200) {
      posts = getEntityAttributesFromStrapiList(data);
      pagination = data?.meta?.pagination;
    }
  } catch (error) {
    console.error("Error fetching blog posts", error);
  }

  const staticProps: {
    props: BlogPagePropsI;
    revalidate: number;
  } = {
    props: {},
    revalidate: ISR_REVALIDATE_INTERVAL_SECONDS,
  };

  // NOTE `undefined` cannot be serialized as JSON. Please use `null` or omit this value.
  if (posts && posts.length > 0) {
    staticProps.props.posts = posts;
  }

  if (pagination) {
    staticProps.props.pagination = pagination;
  }

  return staticProps;
};

export default BlogPage;
